module.exports = __webpack_public_path__ + "static/media/supportBackground.67293629.svg";